import { defineMessages } from 'react-intl';

export default defineMessages({
    year: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Year',
        defaultMessage: '* Year'
    },
    brandManufacturer: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Brand/ Manufacturer',
        defaultMessage: '* Brand/ Manufacturer'
    },
    serialNumber: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Serial Number',
        defaultMessage: '* Serial Number'
    }, 
    fuelType: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.* Fuel Type',
        defaultMessage: '* Fuel Type'
    },
    fueTypIfOthPleSpeFie: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Fuel Type - If other, please specify',
        defaultMessage: '* Fuel Type - If other, please specify'
    },
    value: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Value ($)',
        defaultMessage: 'Value ($)'
    },
    remove: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Remove',
        defaultMessage: 'Remove'
    },
    add: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Add',
        defaultMessage: 'Add'
    },
     addMainEngine: {
        id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Add Main Engine',
        defaultMessage: 'Add Main Engine'
    },
    removeMainEngine:{
    id: 'quoteandbind.RecMarLinedirectives.templates.MainEngineTable.Remove Accident',
    defaultMessage: 'Removed Main Engine {brandDesc}'
    },
});